export default __webpack_public_path__ + "static/media/coming_soon_top.87b195af.svg";